/**
 * @file コンポーネント：症例ラベルリスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    padding: 4px;
`;

export const StyledListItem = styled.li`
    margin-right: 8px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledListLabel = styled.p`
    padding: 4px;
    color: #ffffff;
    font-size: 13px;
    line-height: 16px;

    &[data-label="editor"] {
        background-color: #e0b03b;
        color: #000000;
    }

    &[data-label="new"] {
        background-color: #c31a1e;
    }

    &[data-label="nonoperation"] {
        background-color: #061c72;
    }

    &[data-label="operation"] {
        background-color: #00b700;
    }
`;
